import React, { useContext } from 'react';

import { Modal } from 'app/design-system/components/Modal';
import { useTranslation } from 'app/lang';
import { allowFreshChat } from 'app/ssr/config';

import { RegContext } from '../../context';
import { getHeaderContent } from '../../utils/signing-helpers';
import { SigningHelpButton } from '../SigningHelpButton';

import styles from './Header.module.scss';

export const Header = () => {
  const { t } = useTranslation();
  const { regData } = useContext(RegContext);

  return (
    <Modal.Header data-test="Modal-Signing-header"
                  className={styles.headerContent}>
      <p className={styles.title}>
        {t(getHeaderContent(regData))}
      </p>
      {allowFreshChat && <SigningHelpButton />}
    </Modal.Header>
  );
};
